// extracted by mini-css-extract-plugin
export default {"content-wrapper":"Order_content-wrapper__hHDi8","content-container":"Order_content-container__O0vhK","order-comp":"Order_order-comp__Y8zpb"};